<h3 class="person-name clearfix">
  <a [routerLink]="personLink">
    <span>{{ personName }}<sup hcfFootnote [footnoteText]="person.notes" *ngIf="person.notes"></sup></span>
    <span
      *ngIf="person.isAffiliatedProvider"
      class="ic-status-affiliated"
      title="An Affiliated Provider will organise prior approval with
 us and claim on your behalf for eligible healthcare
 services - so you don't need to submit a claim. You
 may need to see an Affiliated Provider in order to be
 covered under your policy."></span>
    <span *ngIf="person.isConsultant" class="is-consultant" title="{{ settings.values.consultIconTitle }}"></span>
    <span
      *ngIf="person.isTelehealth"
      class="is-telehealth"
      title="{{ settings.values.virtualConsultationTitle }}"></span>
  </a>
</h3>
<h4 class="specialty" *ngIf="person.specialty">{{ person.specialty }}</h4>
<div class="special-interests" *ngIf="person.specialInterest"> Special interest(s): {{ person.specialInterest }} </div>
<ul class="plain-list">
  <li
    *ngFor="let phone of person.phones"
    class="ic-phone"
    [innerHTML]="phone.number | phoneLinkedWithDescription: phone.description"></li>
</ul>
<div class="ic-email" *ngIf="person.emailAddress" aria-label="Email">
  <a href="mailto:{{ person.emailAddress }}">{{ person.emailAddress }}</a>
</div>

<div class="search-result-buttons">
  <button class="people" [routerLink]="personLink"> Check services <span class="arrow-right"></span> </button>
</div>
